import { HttpEventType, HttpResponse } from '@angular/common/http';
import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import * as _ from 'lodash';
import { interval, Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { DocumentService } from 'src/app/services/document.service';
import { EDocumentType } from './document-type';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PDREDonneesAdministrativesDTO } from 'src/app/services/DTO/PDRE-donnees-administratives.dto';


export enum ELoadingState {
    Waiting,
    Uploading,
    PendingServer,
    Finishing
}
@Component({
    selector: 'app-multiple-file-upload-box',
    templateUrl: 'multiple-file-upload-box.html',
    styleUrls: ['./multiple-file-upload-box.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MultipleFileUploadBoxDialog {
    ELoadingState = ELoadingState;
    Files: File[] = [];
    PercentDone = 0;
    Accept: string;
    event: any;
    private Sub: Subscription = null;
    private strategyId;
    private type: EDocumentType;
    multiple: boolean = true
    CurrentState: ELoadingState = null;

    private SEND_REQUEST_PERCENTAGE = 80; // percentage of progress bar to reach when the request is still in progress, the rest will be done by an interval until the request is completed

    UPLOADING_LABEL: string = 'Uploading';
    EXTRACTING_LABEL: string = 'Extracting information from the file';
    RETRIEVING_SERVER_RESPONSE_LABEL: string = 'Retrieving server response';
    FINISHING_LABEL: string = 'Finishing...';
    private label: string = '';

    public get CanAddDocument() {
        if (this.PercentDone > 0 && this.PercentDone < 100)
            return false;
        if (this.type === EDocumentType.AreaMap) {
            return this.Files.length === 1;
        } else {
            return this.Files.length > 0;
        }
    }

    public get IsDocumentAPDRE() {
        return this.type === EDocumentType.PDRE;
    }

    constructor(
        public dialogRef: MatDialogRef<MultipleFileUploadBoxDialog>,
        private documentService: DocumentService,
        @Inject(MAT_DIALOG_DATA) public data) {
        // this.strategyId = data.strategyId;
        this.type = data.type ?? EDocumentType.AreaMap;
        // if (this.type === EDocumentType.AreaMap) {
        //     this.Accept = '.png,.jpg';
        // } else {
        //     this.Accept = '.docx,application/pdf';
        // }

        this.multiple = this.type === EDocumentType.PDRE ? false : true;
        this.SEND_REQUEST_PERCENTAGE = this.IsDocumentAPDRE ? 30 : 80;
    }

    onCancel(): void {
        this.dialogRef.close();
    }

    onFileChange(event) {

        const files = event.srcElement.files as File[];
        if (files) {
            this.Files.push(...Array.from<File>(files));
        }
        this.Files = _.uniqBy(this.Files, 'name');
    }

    onFileFromDragNDrop(event: any) {
        let files = event instanceof FileList ? event : event.files;

        for (let index = 0; index < files.length; index++) {
            const element = files[index];
            this.Files.push(element);
        }
        this.Files = _.uniqBy(this.Files, 'name');
    }

    remove(file: File): void {
        const index = this.Files.indexOf(file);

        if (index >= 0) {
            this.Files.splice(index, 1);
        }
    }

    uploadDocument() {
        switch (this.type) {
            case EDocumentType.AreaMap:
            case EDocumentType.PortFolio:
                this.sendDocument();
                break;
            case EDocumentType.PDRE:
                this.sendDocumentPDRE();
                break;
        }
    }
    private clearSub() {
        if (this.Sub) {
            try {
                this.Sub.unsubscribe();
            } catch (e) {
                // noop
            }
            this.Sub = null;
        }
    }

    private ensureProgressInterval() {
        if (!this.Sub) {
            this.Sub = interval(100).subscribe(() => {

                if (this.CurrentState === ELoadingState.Uploading && this.event) {

                    this.PercentDone = Math.round(this.SEND_REQUEST_PERCENTAGE * this.event.loaded / this.event.total)
                    this.label = this.UPLOADING_LABEL;
                }
                if (this.CurrentState === ELoadingState.PendingServer && this.PercentDone < 95) { // Pour Florian : sinon donne l'impression que ca plante
                    this.PercentDone = this.PercentDone + 1;
                    this.label = this.type === EDocumentType.PDRE ? this.EXTRACTING_LABEL : this.RETRIEVING_SERVER_RESPONSE_LABEL;
                } else if ((this.CurrentState === ELoadingState.PendingServer && this.PercentDone >= 95 && this.PercentDone <= 99)) {
                    this.PercentDone = this.PercentDone + 0.1; // to trigger change detection
                }
                if (this.CurrentState === ELoadingState.Finishing) {
                    this.PercentDone = 100;
                    this.label = this.FINISHING_LABEL;
                }
                console.log('Progress:', this.CurrentState + ': ' + this.PercentDone, '%');
            });

        }
    }

    private handleUpload(observable: any, onSuccess: (body: any) => void) {
        observable
            .pipe(filter((e: any) => e instanceof HttpResponse || e.type === HttpEventType.UploadProgress))
            .subscribe(
                async event => {
                    this.event = event as any;
                    // await new Promise((resolve, reject) => {

                    //     if (this.PercentDone >= this.SEND_REQUEST_PERCENTAGE) {

                    //     }
                    //     if (this.PercentDone === 100)
                    //         resolve(true);
                    // });
                    this.ensureProgressInterval()

                    if (event.type === HttpEventType.UploadProgress) {
                        this.CurrentState = ELoadingState.Uploading;
                        // this.PercentDone = Math.round(this.SEND_REQUEST_PERCENTAGE * event.loaded / event.total);
                        if (Math.round(event.loaded / event.total) === 1) {
                            setTimeout(() => {
                                this.CurrentState = ELoadingState.PendingServer;
                            }, 100);
                        }
                    }

                    if (event instanceof HttpResponse) {
                        this.CurrentState = ELoadingState.Finishing;

                        setTimeout(() => {
                            this.clearSub();
                            onSuccess(event.body);
                        }, 1000);
                    }
                },
                (err) => {
                    this.clearSub();
                    this.label = 'Error !';
                    this.dialogRef.close();
                    console.log('Upload Error:', err);
                }

            );
    }

    sendDocument() {
        this.handleUpload(this.documentService.createDocument(this.Files), (body) => {
            this.dialogRef.close(body); // EDM ID
        });
    }

    sendDocumentPDRE() {
        this.handleUpload(this.documentService.createPDRE(this.Files), (body) => {
            const info: PDREDonneesAdministrativesDTO = PDREDonneesAdministrativesDTO.mapFromJSON(body);
            this.dialogRef.close([info]); // PDRE informations extracted from the file
        });
    }
}
